import { ImageWrapper } from "../content/image-wrapper";
import { CmsImage } from "../content/cms-image";

type Props = {
  src: string;
  alt?: string;
  caption?: string;
  accentCaption?: boolean;
};

export const Image = ({
  src = "",
  alt = "",
  caption,
  accentCaption,
}: Props) => {
  return (
    <ImageWrapper caption={caption} accentCaption={accentCaption}>
      <CmsImage image={src} alt={alt} />
    </ImageWrapper>
  );
};
